import { default as a } from "./web.js";
(function() {
  try {
    var e = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, d = new e.Error().stack;
    d && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[d] = "a9f5cade-e95b-4b2f-9218-b67a60ad3c29", e._sentryDebugIdIdentifier = "sentry-dbid-a9f5cade-e95b-4b2f-9218-b67a60ad3c29");
  } catch (n) {
  }
})();
export {
  a as default
};
//# sourceMappingURL=index.js.map
